<template>
    <dash
        icon="fa fa-book"
        titulo="CONTRATAÇÕES SGF"
        subTitulo="GERENTE"
        @click.native="$router.push({ name: 'Gerentes_Contratacoes' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
